import { useSyncExternalStore } from 'react';
import { pwaInstall, isIOS, isIOSSafari, isAndroid } from '~/pwa/pwaInstall';

// Hook udostępniający aktualny stan instalacji PWA komponentom React.
// Czyta z globalnego store'a (pwaInstall) przez useSyncExternalStore, więc reaguje
// na asynchroniczne zdarzenia beforeinstallprompt / appinstalled bez ręcznego setState.
export function usePwaInstall() {
  const deferred = useSyncExternalStore(
    pwaInstall.subscribe,
    pwaInstall.getDeferred,
  );
  const isInstalled = useSyncExternalStore(
    pwaInstall.subscribe,
    pwaInstall.isInstalled,
  );

  return {
    // Android/Chrome: natywny prompt jest gotowy do wywołania jednym kliknięciem.
    canPromptAndroid: deferred !== null,
    isIOS: isIOS(),
    isIOSSafari: isIOSSafari(),
    isAndroid: isAndroid(),
    isInstalled,
    // Dymek pokazujemy ZAWSZE, dopóki aplikacja nie jest uruchomiona jako zainstalowana PWA.
    // Gdy natywny prompt jest niedostępny, kliknięcie pokaże instrukcję (jak na iPhone).
    canInstall: !isInstalled,
    promptInstall: pwaInstall.promptInstall,
  };
}
